import { Input, Label } from "@istari-frontend/ui";
import { useId } from "react";

import { ChatInfosecLevelSelect, type InfosecLevelOption } from "~/ai-chat/ui/chat-infosec-level-select";

interface ChatClassifyFieldsProps {
  name: string;
  onNameChange: (name: string) => void;
  // Whether to show the infosec level select — off on deployments without infosec.
  showInfosecLevel: boolean;
  infosecLevels: InfosecLevelOption[];
  defaultInfosecLevel?: InfosecLevelOption | null;
  // null = platform default.
  infosecLevelId: string | null;
  onInfosecLevelChange: (id: string | null) => void;
}

// The name + infosec-classification inputs shared by the save dialog and the share modal's classify step.
export function ChatClassifyFields({
  name,
  onNameChange,
  showInfosecLevel,
  infosecLevels,
  defaultInfosecLevel,
  infosecLevelId,
  onInfosecLevelChange,
}: ChatClassifyFieldsProps) {
  const nameInputId = useId();
  const infosecLevelSelectId = useId();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor={nameInputId} className="text-xs">
          Name
        </Label>
        <Input
          id={nameInputId}
          value={name}
          onChange={(event) => onNameChange(event.target.value)}
          placeholder="Istari chat"
        />
      </div>
      {showInfosecLevel && (
        <ChatInfosecLevelSelect
          id={infosecLevelSelectId}
          value={infosecLevelId}
          onChange={onInfosecLevelChange}
          levels={infosecLevels}
          defaultLevel={defaultInfosecLevel}
        />
      )}
    </div>
  );
}
